import script from "./BookCompetition.vue?vue&type=script&setup=true&lang=js"
export * from "./BookCompetition.vue?vue&type=script&setup=true&lang=js"

import "./BookCompetition.vue?vue&type=style&index=0&id=36263066&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36263066"]])

export default __exports__